import { DeclaracionModelo303DtoProps } from "api/DTOs/DeclaracionModelo303Dto"
import { PERIODO_DECLARACION_MODELO_ENUM } from "api/Types/PeriodoDeclaracionModeloEnum"
import { TIPO_DECLARACION_DECLARACION_MODELO } from "api/Types/TipoDeclaracionDeclaracionModeloEnum"
import { TRIMESTRE_ENUM } from "api/Types/TrimestreEnum"
import { TFunction } from "i18next"
import fileDownload from "js-file-download"

export const getPeriodoDeclaracion = (periodo?: number) => {
  switch (periodo) {
    case TRIMESTRE_ENUM.PRIMER_TRIMESTRE:
      return { label: "1T", value: PERIODO_DECLARACION_MODELO_ENUM.Trimestre_1 }
    case TRIMESTRE_ENUM.SEGUNDO_TRIMESTRE:
      return { label: "2T", value: PERIODO_DECLARACION_MODELO_ENUM.Trimestre_2 }
    case TRIMESTRE_ENUM.TERCER_TRIMESTRE:
      return { label: "3T", value: PERIODO_DECLARACION_MODELO_ENUM.Trimestre_3 }
    case TRIMESTRE_ENUM.CUARTO_TRIMESTRE:
      return { label: "4T", value: PERIODO_DECLARACION_MODELO_ENUM.Trimestre_4 }
    default:
      return { label: "", value: null }
  }
}

const DECLARACION_TYPE_ARRAY = (t: TFunction) => [
  {
    label: t("taxSummary.declaracion.array.compensacion"),
    value: TIPO_DECLARACION_DECLARACION_MODELO.C,
  },
  {
    label: t("taxSummary.declaracion.array.devolucion"),
    value: TIPO_DECLARACION_DECLARACION_MODELO.D,
  },
  {
    label: t("taxSummary.declaracion.array.tributariaIngreso"),
    value: TIPO_DECLARACION_DECLARACION_MODELO.G,
  },
  {
    label: t("taxSummary.declaracion.array.ingreso"),
    value: TIPO_DECLARACION_DECLARACION_MODELO.I,
  },
  {
    label: t("taxSummary.declaracion.array.cero"),
    value: TIPO_DECLARACION_DECLARACION_MODELO.N,
  },
  {
    label: t("taxSummary.declaracion.array.tributacionDevolucion"),
    value: TIPO_DECLARACION_DECLARACION_MODELO.V,
  },
  {
    label: t("taxSummary.declaracion.array.domiciliacion"),
    value: TIPO_DECLARACION_DECLARACION_MODELO.U,
  },
  {
    label: t("taxSummary.declaracion.array.domiciliacionExterior"),
    value: TIPO_DECLARACION_DECLARACION_MODELO.X,
  },
]

export const calculateCasilla27CuotaDevengada = ({
  dp30301,
}: DeclaracionModelo303DtoProps) => {
  return (
    (dp30301?.casilla152 ?? 0) +
    (dp30301?.casilla167 ?? 0) +
    (dp30301?.casilla03 ?? 0) +
    (dp30301?.casilla155 ?? 0) +
    (dp30301?.casilla06 ?? 0) +
    (dp30301?.casilla09 ?? 0) +
    (dp30301?.casilla11 ?? 0) +
    (dp30301?.casilla13 ?? 0) +
    (dp30301?.casilla15 ?? 0) +
    (dp30301?.casilla158 ?? 0) +
    (dp30301?.casilla170 ?? 0) +
    (dp30301?.casilla18 ?? 0) +
    (dp30301?.casilla21 ?? 0) +
    (dp30301?.casilla24 ?? 0) +
    (dp30301?.casilla26 ?? 0)
  )
}

export const calculateCasilla45TotalDeducir = ({
  dp30301,
}: DeclaracionModelo303DtoProps) => {
  return (
    (dp30301?.casilla29 ?? 0) +
    (dp30301?.casilla31 ?? 0) +
    (dp30301?.casilla33 ?? 0) +
    (dp30301?.casilla35 ?? 0) +
    (dp30301?.casilla37 ?? 0) +
    (dp30301?.casilla39 ?? 0) +
    (dp30301?.casilla41 ?? 0) +
    (dp30301?.casilla42 ?? 0) +
    (dp30301?.casilla43 ?? 0) +
    (dp30301?.casilla44 ?? 0)
  )
}

export const calculateCasilla46ResultadoRegimenGeneral = (
  values: DeclaracionModelo303DtoProps
) => {
  return (
    calculateCasilla27CuotaDevengada(values) -
    calculateCasilla45TotalDeducir(values)
  )
}

export const calculateCasilla64SumaResultados = (
  values: DeclaracionModelo303DtoProps
) => {
  return (
    calculateCasilla46ResultadoRegimenGeneral(values) +
    (values.dp30303?.casilla76 ?? 0)
    // todo: descomentar cuando se implante regimen simplificado
    // + (values.dp30302?.casilla58 ?? 0
  )
}

export const calculateCasilla66AtribuibleAdministracion = (
  values: DeclaracionModelo303DtoProps
) => {
  return (
    calculateCasilla64SumaResultados(values) *
    ((values.dp30303?.casilla65 ?? 0) / 100)
  )
}

export const calculateCasilla87Compensar = ({
  dp30303,
}: DeclaracionModelo303DtoProps) => {
  return (dp30303?.casilla110 ?? 0) - (dp30303?.casilla78 ?? 0)
}

export const calculateCasilla69Autoliquidacion = (
  values: DeclaracionModelo303DtoProps
) => {
  return (
    calculateCasilla66AtribuibleAdministracion(values) +
    (values.dp30303?.casilla77 ?? 0) -
    (values.dp30303?.casilla78 ?? 0) +
    (values.dp30303?.casilla68 ?? 0) +
    (values.dp30303?.casilla108 ?? 0)
  )
}

export const calculateCasilla71Resultado = (
  values: DeclaracionModelo303DtoProps
) => {
  return (
    calculateCasilla69Autoliquidacion(values) -
    (values.dp30303?.casilla70 ?? 0) +
    (values.dp30303?.casilla109 ?? 0)
  )
}

export const DECLARACION_TYPE_ARRAY_FUNC = (
  values: DeclaracionModelo303DtoProps,
  t: TFunction
) => {
  const resultado = calculateCasilla71Resultado(values)

  const array = DECLARACION_TYPE_ARRAY(t)
  switch (true) {
    case resultado === 0:
      return array.filter(
        (item) => item.value === TIPO_DECLARACION_DECLARACION_MODELO.N
      )

    case resultado < 0:
      return array.filter(
        (item) =>
          item.value === TIPO_DECLARACION_DECLARACION_MODELO.C ||
          item.value === TIPO_DECLARACION_DECLARACION_MODELO.D
      )

    case resultado > 0:
      return array.filter(
        (item) => item.value === TIPO_DECLARACION_DECLARACION_MODELO.I
      )

    default:
      return array
  }
}

export const handleDownloadTxtModelo303 = async (
  data: Blob
  // serie: string,
) => {
  try {
    const blob = new Blob([data], { type: "text/plain;charset=utf-8" })

    fileDownload(blob, `Modelo_303Declaracion.txt`)

    // notification.success({ body: t("successMsg.downloadDocument") })
  } catch (error) {
    // notification.errorServidor({
    //   body: t("errorMsg.downloadDocument"),
    // })
  }
}
